(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ukff-artwork-request"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialiseArtworkRequests = () => {
    const params = new URLSearchParams(window.location.search);
    document.querySelectorAll('[data-ukff-artwork-form]').forEach((container) => {
      const context = container.querySelector('[data-request-context]');
      const productName = container.querySelector('[data-request-product-name]');
      const productLink = container.querySelector('[data-request-product-link]');
      const title = (params.get('product') || '').slice(0, 200).trim();
      const productPath = params.get('product_path') || '';
      if (context && productName && title) {
        productName.textContent = title;
        context.hidden = false;
      }
      if (productLink && /^\/products\/[a-z0-9-]+$/.test(productPath)) {
        productLink.href = productPath;
        productLink.hidden = false;
      }
      const embed = container.querySelector('[data-ukff-hulk-embed]');
      if (!embed || embed.dataset.ukffObserved) return;
      embed.dataset.ukffObserved = 'true';
      const titleFrame = () => {
        const frame = embed.querySelector('iframe');
        if (!frame) return false;
        frame.title = embed.dataset.formTitle;
        return true;
      };
      if (!titleFrame()) {
        const observer = new MutationObserver(() => {
          if (titleFrame()) observer.disconnect();
        });
        observer.observe(embed, { childList: true });
        window.setTimeout(() => observer.disconnect(), 30000);
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialiseArtworkRequests, { once: true });
  else initialiseArtworkRequests();
  document.addEventListener('shopify:section:load', initialiseArtworkRequests);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ukff-artwork-upload"] && !Shopify.designMode) return;
  try {
    (() => {
  const selectedFiles = new WeakMap();
  const initialiseUploads = () => {
    document.querySelectorAll('[data-ukff-upload]').forEach((container) => {
      if (selectedFiles.has(container)) return;
      const picker = container.querySelector('[data-upload-picker]');
      const form = picker?.form;
      if (!picker || !form || !('FormDataEvent' in window)) return;
      selectedFiles.set(container, []);
      picker.multiple = true;
      const list = container.querySelector('[data-upload-list]');
      const status = container.querySelector('[data-upload-status]');
      const error = container.querySelector('[data-upload-error]');
      const buttonText = container.querySelector('[data-upload-button-text]');
      const clear = container.querySelector('[data-upload-clear]');
      const renderFiles = () => {
        const files = selectedFiles.get(container);
        list.replaceChildren();
        files.forEach((file, index) => {
          const row = document.createElement('li');
          const filename = document.createElement('span');
          filename.className = 'ukff-upload__filename';
          filename.textContent = file.name;
          const size = document.createElement('span');
          size.className = 'ukff-upload__size';
          size.textContent = file.size >= 1048576 ? `${(file.size / 1048576).toFixed(1)} MB` : `${Math.max(1, Math.ceil(file.size / 1024))} KB`;
          filename.append(size);
          const remove = document.createElement('button');
          remove.type = 'button';
          remove.className = 'ukff-upload__remove';
          remove.textContent = container.dataset.removeLabel;
          remove.setAttribute('aria-label', `${container.dataset.removeLabel} ${file.name}`);
          remove.addEventListener('click', () => {
            selectedFiles.set(container, selectedFiles.get(container).filter((_, i) => i !== index));
            error.hidden = true;
            picker.setCustomValidity('');
            renderFiles();
            picker.focus();
          });
          row.append(filename, remove);
          list.append(row);
        });
        status.textContent = files.length ? `${files.length} ${files.length === 1 ? container.dataset.singleLabel : container.dataset.selectedLabel}` : container.dataset.emptyLabel;
        buttonText.textContent = files.length ? container.dataset.addLabel : container.dataset.chooseLabel;
        clear.hidden = files.length === 0 && error.hidden;
      };
      clear.addEventListener('click', () => {
        selectedFiles.set(container, []);
        picker.value = '';
        picker.setCustomValidity('');
        error.hidden = true;
        renderFiles();
        picker.focus();
      });
      picker.addEventListener('change', () => {
        const incoming = Array.from(picker.files || []);
        if (!incoming.length) return;
        const existing = selectedFiles.get(container);
        const combined = [...existing];
        incoming.forEach((file) => {
          if (!combined.some((item) => item.name === file.name && item.size === file.size && item.lastModified === file.lastModified)) combined.push(file);
        });
        let message = '';
        if (incoming.some((file) => !/\.(pdf|jpe?g|png|svg|webp)$/i.test(file.name))) message = container.dataset.errorType;
        else if (incoming.some((file) => file.size === 0)) message = container.dataset.errorEmpty;
        else if (incoming.some((file) => file.size > 10 * 1024 * 1024)) message = container.dataset.errorSize;
        else if (combined.length > 5) message = container.dataset.errorCount;
        else {
          let total = combined.reduce((sum, file) => sum + file.size, 0);
          form.querySelectorAll('[data-ukff-upload]').forEach((other) => {
            if (other !== container) total += (selectedFiles.get(other) || []).reduce((sum, file) => sum + file.size, 0);
          });
          if (total > 20 * 1024 * 1024) message = container.dataset.errorTotal;
        }
        picker.value = '';
        picker.setCustomValidity(message);
        error.hidden = !message;
        error.textContent = message;
        clear.hidden = !message && existing.length === 0;
        if (!message) {
          selectedFiles.set(container, combined);
          renderFiles();
        }
      });
      form.addEventListener('formdata', (event) => {
        event.formData.delete(`properties[${container.dataset.propertyName}]`);
        selectedFiles.get(container).forEach((file, index) => {
          const suffix = index === 0 ? '' : ` ${index + 1}`;
          event.formData.set(`properties[${container.dataset.propertyName}${suffix}]`, file, file.name);
        });
      });
      form.addEventListener('submit', (event) => {
        if (!picker.checkValidity()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          picker.reportValidity();
        }
      }, true);
      form.addEventListener('reset', () => {
        selectedFiles.set(container, []);
        picker.setCustomValidity('');
        error.hidden = true;
        renderFiles();
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialiseUploads, { once: true });
  else initialiseUploads();
  document.addEventListener('shopify:section:load', initialiseUploads);
})();
  } catch(e) { console.error(e); }
})();

})();
